import { observer } from 'mobx-react-lite'
import { type CountryCode } from 'libphonenumber-js'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'
import { RcsWizardSteps } from 'pages/settings/pages/rcsV2/route/type'
import { CountryRow } from './CountryRow/CountryRow'

import styles from './styles.module.scss'

const COUNTRIES: { code: CountryCode; label: string }[] = [
  { code: 'US', label: 'United States' },
  { code: 'CA', label: 'Canada' },
  { code: 'GB', label: 'United Kingdom' },
]

export const Countries = observer(() => {
  const { countriesStore, navigationStore } = useRcsWizardContext()

  const onNext = () => {
    navigationStore.goToNextStep(RcsWizardSteps.countries)
  }

  return (
    <div className={styles.wrap}>
      <PageDescription>
        Select the countries where you want to enable your RCS sender. Requirements vary by country,
        and we’ll guide you through the registration process.
      </PageDescription>

      <div className={styles.list}>
        {COUNTRIES.map(({ code, label }) => (
          <CountryRow
            key={code}
            country={code}
            label={label}
            checked={countriesStore.isCountryActive(code)}
            onToggle={countriesStore.toggleCountry}
          />
        ))}
      </div>

      <NextButton text='Next' disabled={countriesStore.isNextDisabled} onClick={onNext} />
    </div>
  )
})
